import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { PortalAnnouncements } from "@/components/portal/portal-announcements";
import { portalAnnouncementsQuery, requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/announcements")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "broadcasts"),
  loader: ({ context }) => context.queryClient.ensureQueryData(portalAnnouncementsQuery),
  component: PortalAnnouncementsPage,
});

function PortalAnnouncementsPage() {
  const { data } = useQuery(portalAnnouncementsQuery);
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">Announcements</h1>
        <p className="text-muted-foreground text-sm">Company-wide messages from your HR team.</p>
      </div>
      <PortalAnnouncements announcements={data ?? []} />
    </div>
  );
}
